module.exports = __webpack_public_path__ + "img/Pattern06.0520dddf.png";